import { render, staticRenderFns } from "./BindAccount.vue?vue&type=template&id=5347f5bc&scoped=true&"
import script from "./BindAccount.vue?vue&type=script&lang=js&"
export * from "./BindAccount.vue?vue&type=script&lang=js&"
import style0 from "./BindAccount.vue?vue&type=style&index=0&id=5347f5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347f5bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5347f5bc')) {
      api.createRecord('5347f5bc', component.options)
    } else {
      api.reload('5347f5bc', component.options)
    }
    module.hot.accept("./BindAccount.vue?vue&type=template&id=5347f5bc&scoped=true&", function () {
      api.rerender('5347f5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welfareCenter/BindAccount.vue"
export default component.exports